module.exports = __webpack_public_path__ + "img/img-7.345e02cb.png";